module.exports = __webpack_public_path__ + "static/img/home_new20.b0962a75.jpg";